<template>
  <!-- accordion like settings-->

  <v-card class="fluid-column ma-5">


    <div>
    <v-card-item>
      <v-card-title class="text-headline-small">Raccolta dati</v-card-title>
    </v-card-item>
    <v-card-text>

      È possibile raccogliere le tipologie:
      <ul class="pl-6">
        <li>segnalazioni</li>
        <li>media</li>
        <li>giornate diario</li>
      </ul>
    </v-card-text>
    </div>
    


    <div><v-card-item>
      <v-card-title class="text-headline-small">Modifica dati</v-card-title>
    </v-card-item>
    <v-card-text>

      È possibile modificare i dati raccolti:
      <ul class="pl-6">
        <li>segnalazioni - solo giornata odierna</li>
        <li>giornate diario - fino a {{ dataStore.timers.journalDay.send.text }} nel passato</li>
        <li>media - solo quelli non collegati</li>
      </ul>
    </v-card-text></div>

    <div><v-card-item>
      <v-card-title class="text-headline-small">Invio dati</v-card-title>
    </v-card-item>
    <v-card-text>

      L'applicazione deve essere avviata.<br>
      L'invio dei dati avviene in automatico quando l'applicazione percepisce di essere online e sotto copertura
      dati.<br>
      Durante il caricamento compare l'icona

      <v-icon size="default" color="red-darken-4">mdi-transfer-up</v-icon>

      nella barra principale. <br>
      Puoi controllare lo stato del caricamento nella sezione <router-link to="/data/">Raccolta</router-link> .<br>

      Vengono inviati:
      <ul class="pl-6">
        <li>segnalazioni - giornate precedenti</li>
        <li>giornate diario - almeno {{ dataStore.timers.journalDay.send.text }} nel passato</li>
        <li>media - solo quelli collegati</li>
      </ul>
    </v-card-text></div>


    <div><v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">Media</v-card-title>
    </v-card-item>
    <v-card-text>

      <p class="my-2">
        I media collegati alle segnalazioni "aperte" (giornata odierna):
      </p>
      <ul class="pl-6">
        <li>possono essere eliminati dall'utente</li>
      </ul>
      <p class="my-2">
        I media collegati alle segnalazioni "chiuse" (giornate passate):
      </p>
      <ul class="pl-6">
        <li>sono destinati ad essere trasferiti al server</li>
        <li>possono essere eliminati dall'utente, con una conferma utente</li>
        <li>vengono eliminati in automatico, durante l'eliminazione delle segnalazione correlata</li>
      </ul>

      <p class="my-2">
        I media non collegati:
      </p>
      <ul class="pl-6">
        <li>non sono destinati al trasferimento,</li>
        <li>non sono vengono rimossi in automatico</li>
        <li>possono essere collegati a posteriori</li>
      </ul>



    </v-card-text></div>



    <div><v-card-item>
      <v-card-title class="text-headline-small">Rimozione dati</v-card-title>
      <v-card-title class="text-title-large text-grey-darken-2">Segnalazioni</v-card-title>
    </v-card-item>
    <v-card-text>

      <p class="my-2">
        I dati acquisiti vengono rimossi automaticamente quando entrambe le condizioni sono verificate:<br>
      </p>
      <ul class="pl-6">
        <li>il dato è stato trasferito al server </li>
        <li>il dato è stato acquisito da almeno {{ dataStore.timers.dayFeature.send.text }}</li>
      </ul>
    </v-card-text></div>




    <div><v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">Diario</v-card-title>
    </v-card-item>
    <v-card-text>
      I dati acquisiti vengono rimossi automaticamente quando entrambe le condizioni sono verificate:<br>
      <ul class="pl-6">
        <li>il dato è stato trasferito al server </li>
        <li>il dato è stato acquisito da almeno {{ dataStore.timers.journalDay.delete.text }}</li>
      </ul>
    </v-card-text></div>


    <div><v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">Riassunto timer</v-card-title>
    </v-card-item>
    <v-card-text>

      <v-table density='compact'>
        <thead>
          <tr>
            <th class="text-left">
              Timer</th>
            <th class="text-left">
              Periodo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
          </tr>

          <tr>
            <td>Raccolta dati - invio</td>
            <!-- <td v-html="usageAmount.caches"></td> -->
            <td>{{ dataStore.timers.dayFeature.send.text }}
            </td>
          </tr>
          <tr>
            <td>Raccolta dati - cancellazione</td>
            <!-- <td v-html="usageAmount.caches"></td> -->
            <td>{{ dataStore.timers.dayFeature.delete.text }}
            </td>
          </tr>
          <tr>
            <td>Diario - invio dati</td>
            <!-- <td v-html="usageAmount.caches"></td> -->
            <td>{{ dataStore.timers.journalDay.send.text }}
            </td>
          </tr>
          <tr>
            <td>Diario - cancellazione</td>
            <!-- <td v-html="usageAmount.caches"></td> -->
            <td>{{ dataStore.timers.journalDay.delete.text }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text></div>


    <div><v-card-item>
      <v-card-title class="text-headline-small">Infrastruttura</v-card-title>
    </v-card-item>
    <v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">Software</v-card-title>
    </v-card-item>
    <v-card-text>
      Il software scelto per lo sviluppo è open-source.<br>
      Fra gli strumenti ed i linguaggi utilizzati:
      <ul class="pl-6">
        <li>GNU/Linux</li>
        <li>HTML</li>
        <li>Javascript</li>
        <li>CSS</li>
        <li>Vue</li>
        <li>Vuetify</li>
        <li>IndexedDB</li>
        <li>Workbox</li>
        <li>Node</li>
        <li>Python</li>
        <li>Django</li>
        <li>Gunicorn</li>
        <li>Waitress</li>
        <li>PostgreSQL</li>
        <li>PostGIS</li>
        <li>The Gimp</li>
        <li>Inkscape</li>
        <li>NGINX</li>
        <li>Docker</li>
        <li>Traefik</li>
      </ul>
    </v-card-text>
  </div>
    <div><v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">Ambiente di staging</v-card-title>
    </v-card-item>
    <v-card-text>
      È disponibile un ambiente di staging.<br>
      Si tratta di una replica quasi esatta di un ambiente di produzione per il test del software.<br>
      Gli ambienti di staging vengono utilizzati per testare codici, build e aggiornamenti per garantire la qualità in
      un ambiente di tipo produzione prima della distribuzione dell'applicazione. L'ambiente di staging richiede una
      copia delle stesse configurazioni di hardware, server, database e cache. Tutto in un ambiente di staging dovrebbe
      essere una copia il più possibile vicina all'ambiente di produzione per garantire che il software funzioni
      correttamente.
    </v-card-text></div>

    <div>
    <v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">WebView</v-card-title>
    </v-card-item>
    <v-card-text>
      Per WebView si intende un componente che consente di visualizzare contenuti web all'interno di un'applicazione. <br>
      La WebView è un'istanza di un browser web integrata all'interno dell'applicazione. <br>
      Il browser utilizzato è 
      <ul class="pl-6">
        <li>Android: dipende dal browser utilizzato in fase di installazione</li>
        <li>Desktop: dipende dal browser utilizzato in fase di installazione</li>
        <li>iOS: WebKit</li>
      </ul>
      In generale, la WebView viene utilizzata per uniformare l'esperienza utente su diverse piattaforme, consentendo agli sviluppatori di creare un'unica interfaccia utente che funziona su più dispositivi. <br>
      Il comportamento dell'applicazione è però leggermente influenzato dalle caratteristiche specifiche del browser utilizzato nella WebView. <br>
    </v-card-text></div>




    
    <div>
    <v-card-item>
      <v-card-title class="text-title-large text-grey-darken-2">Progressive Web Application</v-card-title>
    </v-card-item>
    <v-card-text>
      Una Progressive Web App (PWA) è una tipologia di applicazione web che offre un'esperienza utente simile a quella
      di un'app nativa, combinando i migliori aspetti delle applicazioni web e delle app mobili. <br>
      Caratteristiche:
      <ul class="pl-6">
        <li>accesso offline: possono funzionare anche senza connessione a Internet, grazie alla memorizzazione nella
          cache dei contenuti.</li>
        <li>installazione facile: possono essere installate direttamente dal browser sul dispositivo dell'utente, senza
          passare attraverso app store, e appaiono come icone sullo schermo home.</li>
        <li>aggiornamenti automatici: gli aggiornamenti avvengono in background e sono immediatamente disponibili per
          l'utente senza la necessità di interventi manuali.</li>
        <li>esperienza utente consistente: offrono un'interfaccia utente fluida e reattiva, simile a quella delle app
          native, ma accessibile tramite un browser web.</li>
        <li>indipendenza dal sistema operativo: funzionano su qualsiasi dispositivo dotato di un browser moderno,
          indipendentemente dal sistema operativo (Windows, macOS, Android, iOS, ecc.), garantendo un'ampia
          compatibilità e riducendo la necessità di sviluppare versioni specifiche per diverse piattaforme.</li>
        <li>responsive design: sono progettate per adattarsi a vari formati di schermo e dispositivi, migliorando
          l'accessibilità su desktop e dispositivi mobili.</li>
        <li>prestazioni migliorate: utilizzano tecniche di caching e altre ottimizzazioni per garantire tempi di
          caricamento rapidi e un'ottima performance generale.</li>
        <li>notifiche push: possono inviare notifiche push agli utenti, anche quando l'app non è aperta, mantenendo alta
          l'engagement.</li>
        <li>sicurezza: sono servite tramite HTTPS, assicurando che le comunicazioni tra l'utente e il server siano
          criptate.</li>
      </ul>
    </v-card-text></div>
    <!-- 
    <div><v-card-item>
      <v-card-title>Dati su filesystem</v-card-title>
    </v-card-item>
    <v-card-text>

    (solo Android <v-icon size="x-small" color="green">mdi-android</v-icon>)<br>
    Per poter accedere a mappe e richiami offline è necessario:
    <ul class="ml-6">
      <li>avere la cartella <strong>.pngptracker</strong> (la cartella, cominciando con il punto, è nascosta. Va attivata
        la visualizzazione dei files nascosti)</li>
      <li>scaricare e installare
        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.phlox.simpleserver&hl=it">Simple
          Server</a>
      </li>
      <li>scegliere la cartella <strong>.pngptracker</strong></li>
      <li>impostare la porta 8080</li>
      <li>selezionare unicamente l'interfaccia LO (loopback)</li>
      <li>selezionare l'avvio automatico</li>
      <li>avviare il programma</li>
    </ul>
    In questo modo le mappe e i richiami saranno disponibili offline.
    </v-card-text></div> -->
  </v-card>
</template>

<script setup>

import { useDataStore } from '@/store/data';

const dataStore = useDataStore();

</script>
